import AuthStore, { AuthModel } from "store/auth";
import CmsContentStore, { CmsContentModel } from "store/cmsContent";

export interface StoreModel {
  auth: AuthModel;
  cmsContent: CmsContentModel;
}

const Store: StoreModel = {
  auth: AuthStore,
  cmsContent: CmsContentStore,
};

export default Store;
